import { resolveTimezoneId } from './resolveTimezoneId.js';

/**
 * Normalize the `timezone` of a filters snapshot restored from sessionStorage,
 * so the dispatch and the precedence decision read the same resolved value.
 *
 * Returns `filters` unchanged (same reference) when there is nothing to
 * normalize, so callers can keep using it as a truthiness check.
 *
 * @param {?Object} filters restored filters snapshot, or null/undefined
 * @param {string} [fallbackTimezone='UTC']
 * @returns {?Object}
 */
export function normalizeRestoredFilters(filters, fallbackTimezone = 'UTC') {
	if (!filters || typeof filters !== 'object' || !('timezone' in filters)) return filters;
	return { ...filters, timezone: resolveTimezoneId(filters.timezone, fallbackTimezone) };
}

export default normalizeRestoredFilters;
